import { render } from "./FolderCard.vue?vue&type=template&id=4d11f97d&scoped=true"
import script from "./FolderCard.vue?vue&type=script&lang=js"
export * from "./FolderCard.vue?vue&type=script&lang=js"

import "./FolderCard.vue?vue&type=style&index=0&id=4d11f97d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d11f97d"]])

export default __exports__